import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import { PageHero, Icon, StatBlock, PlaceCard, Button, Watermark } from '../../components/ui';
import { ABOUT } from '../../data/about';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'TouristDestination',
  name: 'Ayodhya',
  description: ABOUT.paragraphs[0],
  url: 'https://ayodhyadham.info/about',
  touristType: ['Pilgrims', 'Cultural tourists', 'History enthusiasts'],
  geo: { '@type': 'GeoCoordinates', latitude: 26.7922, longitude: 82.1998 },
  address: { '@type': 'PostalAddress', addressLocality: 'Ayodhya', addressRegion: 'Uttar Pradesh', addressCountry: 'IN' },
};

export default function About() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title="About Ayodhya"
        description="Learn about Ayodhya's ancient heritage, spiritual significance and living culture — from the Ramayana to the Shri Ram Janmabhoomi Mandir."
        canonicalUrl="/about"
        keywords="about Ayodhya, history of Ayodhya, Ayodhya significance, birthplace of Lord Ram"
        structuredData={schema}
      />
      <PageHero crumbs={[{ label: t('Home'), to: '/' }, { label: t('About Ayodhya') }]} title={t(ABOUT.title)} subtitle={t(ABOUT.subtitle)} image={ABOUT.image} imageAlt={ABOUT.imageAlt}>
        <ul className="feature-list" style={{ marginTop: 10, gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
          {ABOUT.features.map((f) => (
            <li key={f.title}>
              <span className="feature-list__icon"><Icon name={f.icon} size={20} /></span>
              <div><div className="feature-list__title">{t(f.title)}</div><div className="feature-list__body">{t(f.body)}</div></div>
            </li>
          ))}
        </ul>
      </PageHero>

      <div className="container content-wrap">
        <div className="content content--wide">
          <div className="prose">
            {ABOUT.paragraphs.map((p) => <p key={p.slice(0, 24)}>{t(p)}</p>)}
          </div>

          <div className="stat-strip" style={{ margin: '36px 0' }}>
            {ABOUT.stats.map((s) => <StatBlock key={s.label} value={s.value} label={t(s.label)} />)}
          </div>

          <h2 className="h-section" style={{ marginBottom: 18 }}>{t('Highlights of the holy city')}</h2>
          <div className="about__highlights">
            {ABOUT.highlights.map((h) => (
              <PlaceCard key={h.title} image={h.image} title={t(h.title)} subtitle={t(h.body)} to={h.to} cta={t('Explore')} />
            ))}
          </div>

          <div className="cta-band" style={{ marginTop: 40 }}>
            <Watermark variant="mandala" position="top-left" />
            <Watermark variant="mandala" position="bottom-right" />
            <h2 className="cta-band__title">{t('Ready for darshan?')}</h2>
            <p className="cta-band__sub">{t('Plan your visit to the Ram Mandir, find a place to stay and follow a curated itinerary.')}</p>
            <div className="cta-band__actions">
              <Button to="/darshan-booking" icon={<Icon name="temple" size={16} />} iconPosition="left">{t('Darshan Booking')}</Button>
              <Button variant="outline" to="/travel-guide" icon={<Icon name="map" size={16} />} iconPosition="left">{t('Travel Guide')}</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
